/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ObjectTypeModel, { ObjectTypeUsage } from 'cio/models/object-type';
import AlertsService from 'cio/services/alerts';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import EnvironmentService from 'cio/services/environment';
import { Task } from 'ember-concurrency';
import ObjectTypesService from 'cio/services/object-types';

interface Args {
  objectType: ObjectTypeModel;
  objectTypes: ObjectTypeModel[];
  objectTypesUsage: Record<string, ObjectTypeUsage>;
  toggleObjectTypeTask: Task<unknown, [objectType: ObjectTypeModel, active: boolean]>;
}

export default class ObjectsTableStatusComponent extends Component<Args> {
  @service alerts!: AlertsService;
  @service store!: DS.Store;
  @service environment!: EnvironmentService;
  @service objectTypes!: ObjectTypesService;

  get isUsed() {
    return Object.values(this.args.objectTypesUsage[this.args.objectType.id]).some((count) => count > 0);
  }

  get isStatusSwitchDisabled() {
    let { objectType, objectTypes, toggleObjectTypeTask } = this.args;

    if (!this.objectTypes.canConfigureObjectTypes) {
      return 'You do not have permission to configure object types';
    }

    if (toggleObjectTypeTask.isRunning) {
      return 'Saving changes...';
    }

    if (objectType.enabled && this.isUsed) {
      return `${objectType.name} cannot be disabled while it is in use`;
    }

    if (
      objectType.enabled === false &&
      objectTypes.toArray().filter((type) => type.enabled).length >= this.environment.current.maxAllowedObjectTypes
    ) {
      return 'Your plan does not allow any more custom object types. Please disable a different type first.';
    }

    return false;
  }
}
